module.exports = __webpack_public_path__ + "img/RIGID PGG TRUCK_RHD_THUMB.380bb887.jpg";